import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon } from 'lucide-react';
const purchases = [['Carolina M.', 'Buenos Aires'], ['Lucía R.', 'Córdoba'], ['Mariana P.', 'Rosario'], ['Andrea G.', 'Mendoza'], ['Sofía L.', 'La Plata']] as const;
export function SocialProof() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setIndex(current => (current + 1) % purchases.length);
        setVisible(true);
      }, 250);
    }, 6500);
    return () => window.clearInterval(timer);
  }, []);
  const [name, city] = purchases[index];
  return <aside aria-live="polite" className={`fixed bottom-4 left-4 z-30 max-w-[270px] rounded-xl border border-[#d6decf] bg-[#fffdf8] p-3 shadow-lg transition-opacity duration-200 ${visible ? 'opacity-100' : 'opacity-0'}`} data-id="element-38">
      <div className="flex gap-2.5" data-id="element-39">
        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-[#5b7255]" aria-hidden="true" data-id="element-40" />
        <p className="text-xs leading-5 text-[#3e4b3e]" data-id="element-41">
          <strong data-id="element-42">{name}</strong> de {city} compró este libro digital.
        </p>
      </div>
    </aside>;
}